import { Form } from "../../../Form";
import { FieldProps } from "../FieldProps";
import { StandardObjectField } from "./StandardObjectField";
import { FormObjectField } from "./FormObjectField/FormObjectField";
import { UnknownValue } from "../../../ObjectTypeDesigner/UnknownValue";
import * as api from "@crochik/pi-api";

export interface IObjectFieldProps extends FieldProps<object> {
    form: Form;
    readonly?: boolean;
}

export function ObjectField(props: IObjectFieldProps) {
    const { field, value } = props;
    const { options: fieldOptions } = field;
    const options = fieldOptions as api.ObjectFieldOptions;

    // TODO: use another property in options to make explicit ("component"?)
    // check options._t?
    // ...
    // could also check editForms, add form but...
    // ...
    switch (options.objectType) {
        case "*":
            // for now just shows the value (can't edit/add)
            return <UnknownValue value={value} />;

        case "Form":
            return <FormObjectField {...props}/>;
    }

    return <StandardObjectField {...props} />;
}